import { FC, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { fetchLocations } from "../../../store/locationStore/locationThunk";
import LocationSelect from "./LocationSelect";

interface Props {
  value?: any;
  onChange: (locationId: string) => void;
  label?: string;
  activeOnly?: boolean;
  size?: "small" | "medium";
  borderless?: boolean;
  width?: number | string;
  excludeId?: string;
}

// LocationSelect for reports: hidden for single-location accounts, else adds an "All Locations" option.
const LocationReportFilter: FC<Props> = ({ value, onChange, activeOnly = false, excludeId, ...rest }) => {
  const dispatch = useAppDispatch();
  const { locations } = useAppSelector((state) => state.locations);

  useEffect(() => {
    if (!locations || locations.length === 0) dispatch(fetchLocations());
  }, [dispatch]); // eslint-disable-line react-hooks/exhaustive-deps

  const options = (locations || [])
    .filter((l) => (activeOnly ? l.isActive !== false : true))
    .filter((l) => (excludeId ? l._id !== excludeId : true));

  if (options.length <= 1) return null;

  return (
    <LocationSelect
      value={value}
      onChange={onChange}
      activeOnly={activeOnly}
      excludeId={excludeId}
      allOption="All Locations"
      {...rest}
    />
  );
};

export default LocationReportFilter;
